// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"CustomRecognitionStar_iconContainer__lRORn","starContainer":"CustomRecognitionStar_starContainer__RRMxu"};